import React from 'react'
import ReactHTMLParser from 'html-react-parser'
import {Container} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import {simpleConsteedTagConfig} from '@consteed/frontend/utils/richTextConfigurations'

const handleFallback = (element) => element

const handleTag = (
    domNode,
    {handleLinkTag, handleList, handleStrongTag, handleEmTag, handleHeadlineTag},
    parserOptions
) => {
    const _handleLinkTag = typeof handleLinkTag === 'function' ? handleLinkTag : handleFallback
    const _handleList = typeof handleList === 'function' ? handleList : handleFallback
    const _handleStrongTag =
        typeof handleStrongTag === 'function' ? handleStrongTag : handleFallback
    const _handleEmTag = typeof handleEmTag === 'function' ? handleEmTag : handleFallback
    const _handleHeadlineTag =
        typeof handleHeadlineTag === 'function' ? handleHeadlineTag : handleFallback

    switch (domNode.name) {
        case 'a':
            return _handleLinkTag(domNode, parserOptions)
        case 'ul':
            return _handleList(domNode, parserOptions)
        case 'strong':
            return _handleStrongTag(domNode, parserOptions)
        case 'em':
            return _handleEmTag(domNode, parserOptions)
        case 'h1':
        case 'h2':
        case 'h3':
        case 'h4':
            return _handleHeadlineTag(domNode, parserOptions)
        default:
            return false
    }
}

/**
 *
 * @param textStyles
 * @returns {{options: {}, replace: ((function(*): (*|boolean|boolean))|*), textStyles: string}}
 */
const parserOptions = (textStyles = '') => ({
    options: {},
    textStyles: textStyles,
    replace: function replace(domNode) {
        if (domNode && domNode.type === 'tag') {
            return handleTag(domNode, this.options, this)
        }

        return false
    }
})

const RTE = ({
    richText = '',
    tagOptions = simpleConsteedTagConfig,
    textStyles,
    isNested,
    ...props
}) => {
    const _parserOptions = Object.assign({}, parserOptions(textStyles), {options: tagOptions})
    const classNames = `rte-container${!isNested ? ' pdcOuterBox' : ''}`
    return (
        <Container className={classNames} p={0} textStyle={textStyles || ''} {...props}>
            {ReactHTMLParser(richText || '', _parserOptions)}
        </Container>
    )
}

RTE.propTypes = {
    richText: PropTypes.string,
    tagOptions: PropTypes.object,
    textStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isNested: PropTypes.bool
}

export default RTE
